import React, {FC, memo} from "react";
import Icon from "@ant-design/icons";
import {Redirect, Route, Switch} from "react-router-dom";
import LayoutStandard from "../../views/LayoutStandard/LayoutStandard";
import {DashboardSvg} from "../../assets/SVG-Icons";
import i18n from "../../services/i18n";
import {URL_DASHBOARD, URL_DASHBOARD_REPORTS} from "../../models/url";
import DashboardOverview from "./DashboardOverview/DashboardOverview";
import Reports from "./Reports/Reports";
import {useGetCompanyInfoQuery} from "../../generated/graphql";
import {getMainMenuItems} from "../common/MainMenuRoutes";
import useHighestRole from "../../helpers/useHighestRole";
import SecondLevelNavigation from "../common/SecondLevelNavigation";

type DashboardProps = {};

const Dashboard: FC<DashboardProps> = () => {
    const highestRole = useHighestRole();
    const {data: companyInfoData} = useGetCompanyInfoQuery({fetchPolicy: "cache-first"});
    const featureReports = companyInfoData?.companyInfo?.subscription?.featureReports;

    const menuItems = getMainMenuItems({highestRole, featureReports});
    const secondLevelNavigationItems = menuItems.dashboard?.children;

    return (
        <LayoutStandard
            pageTitle={(navOpen) => (navOpen ? <Icon component={DashboardSvg} /> : <span>{i18n.containers.dashboard.Dashboard.title()}</span>)}
            secondLevelNavigation={secondLevelNavigationItems && <SecondLevelNavigation secondLevelNavigationItems={secondLevelNavigationItems} />}
            main={main}
        />
    );
};

const main = (
    <Switch>
        <Route exact path={URL_DASHBOARD} component={DashboardOverview} />
        <Route exact path={URL_DASHBOARD_REPORTS} component={Reports} />
        <Redirect to={URL_DASHBOARD} />
    </Switch>
);

export default memo(Dashboard);
